import * as ActionTypes from '../constants/ActionTypes'
import { getRequest, postRequest_ } from './http'
import { baseurl } from '../constants/constants';
import { refresh } from 'ionicons/icons';
import { getShoppingCart } from '../utils/functions';

export function setData(items, name) {
    return {
        type: ActionTypes.SET_DATA,
        name: name,
        items: items
    }
}

export function setDataConcat(items, name) {
    return {
        type: ActionTypes.DATA_WITH_PAGINATION_CONCAT,
        name: name,
        items: items
    }
}

const get_ = (data, controller) => {
    return (dispatch) => {
        dispatch(setData({
            loading: { Msg: 'Cargando...', isOpen: true },
            refresh_list: false,
            concat_list: false,
            view_active: data.view_active
        }));
        getRequest(data, controller).then(
            (response) => {

                if (data.typeOption == "get_list_units") {
                    if (data.pages == 0) {
                        dispatch(setData({
                            unitsDB: response.data,
                            data_pagin_unitsDB: response.data.data,
                            refresh_list: false,
                            units_list: false,
                            loading: { Msg: 'Cargando...', isOpen: false },
                        }));
                    } else {
                        dispatch(setData({
                            unitsDB: response.data,
                            refresh_list: false,
                            units_list: true,
                            loading: { Msg: 'Cargando...', isOpen: false },
                        }));
                        dispatch(setDataConcat(response.data.data, 'data_pagin_unitsDB'));
                    }
                } else if (data.typeOption == "get_list_categories") {
                    if (data.pages == 0) {
                        dispatch(setData({
                            categoriesDB: response.data,
                            data_pagin_categoriesDB: response.data.data,
                            refresh_list: false,
                            categories_list: false,
                            loading: { Msg: 'Cargando...', isOpen: false },
                        }));
                    } else {
                        dispatch(setData({
                            categoriesDB: response.data,
                            refresh_list: false,
                            categories_list: true,
                            loading: { Msg: 'Cargando...', isOpen: false },
                        }));
                        dispatch(setDataConcat(response.data.data, 'data_pagin_categoriesDB'));
                    }
                } else if (data.typeOption == "get_list_brands") {
                    if (data.pages == 0) {
                        dispatch(setData({
                            brandsDB: response.data,
                            data_pagin_brandsDB: response.data.data,
                            refresh_list: false,
                            brand_list: false,
                            loading: { Msg: 'Cargando...', isOpen: false },
                        }));
                    } else {
                        dispatch(setData({
                            brandsDB: response.data,
                            refresh_list: false,
                            brand_list: true,
                            loading: { Msg: 'Cargando...', isOpen: false },
                        }));
                        dispatch(setDataConcat(response.data.data, 'data_pagin_brandsDB'));
                    }
                } else if (data.typeOption == "get_list_variations") {
                    if (data.pages == 0) {
                        dispatch(setData({
                            variationsDB: response.data,
                            data_pagin_variationsDB: response.data.data,
                            refresh_list: false,
                            variation_list: false,
                            loading: { Msg: 'Cargando...', isOpen: false },
                        }));
                    } else {
                        dispatch(setData({
                            variationsDB: response.data,
                            refresh_list: false,
                            variation_list: true,
                            loading: { Msg: 'Cargando...', isOpen: false },
                        }));
                        dispatch(setDataConcat(response.data.data, 'data_pagin_variationsDB'));
                    }
                } else if (data.typeOption == "get_list_products") {
                    if (data.pages == 0) {
                        dispatch(setData({
                            productsDB: response.data,
                            data_pagin_productsDB: response.data.data,
                            refresh_list: false,
                            variation_list: false,
                            loading: { Msg: 'Cargando...', isOpen: false },
                        }));
                    } else {
                        dispatch(setData({
                            productsDB: response.data,
                            refresh_list: false,
                            variation_list: true,
                            loading: { Msg: 'Cargando...', isOpen: false },
                        }));
                        dispatch(setDataConcat(response.data.data, 'data_pagin_productsDB'));
                    }
                } else if (data.typeOption == "getlocationstockproducts") {
                    dispatch(setData({
                        product_locations_stock: response.data[0],
                        loading: { Msg: 'Cargando...', isOpen: false },

                    }));
                }


            },
            (err) => {
                dispatch(setData({
                    loading: { Msg: 'Ocurrio un error...', isOpen: false },
                }));
            }
        );
    }
};

const post_ = (data, controller) => {
    return (dispatch) => {
        dispatch(setData({
            loading: { Msg: 'Cargando...', isOpen: true },
            refresh_list: false,
            concat_list: false,
            view_active: data.view_active
        }));

        postRequest_(data, controller).then(
            (response) => {

                if (data.typeOption == "saveDataUnit") {

                    let data_default = response.data.data_default ? response.data.data_default : {};
                    let categoories = response.data.data_default.categories ? response.data.data_default.categories : [];
                    let subcategories = [];
                    categoories.forEach((category) => {
                        if (category.sub_categories) {
                            subcategories.push(...category.sub_categories);
                        }
                    });
                    data_default['subcategories'] = subcategories;
                    let units = response.data.data_default.units_array ? response.data.data_default.units_array : [];
                    data_default['subcategories'] = subcategories;
                    data_default['units'] = units;
                    let brands = response.data.data_default.brands ? response.data.data_default.brands : [];
                    data_default['brands'] = brands;

                    dispatch(setData({
                        response: { Msg: response.data.msg, success: response.data.success },
                        simpleToast: true,

                        loading: { Msg: 'Cargando...', isOpen: false },
                        refresh_list: true,
                        data_default: data_default
                    }))
                } else if (data.typeOption == "updateDataUnit") {

                    let data_default = response.data.data_default ? response.data.data_default : {};
                    let categoories = response.data.data_default.categories ? response.data.data_default.categories : [];
                    let subcategories = [];
                    categoories.forEach((category) => {
                        if (category.sub_categories) {
                            subcategories.push(...category.sub_categories);
                        }
                    });
                    data_default['subcategories'] = subcategories;
                    let units = response.data.data_default.units_array ? response.data.data_default.units_array : [];
                    data_default['subcategories'] = subcategories;
                    data_default['units'] = units;
                    let brands = response.data.data_default.brands ? response.data.data_default.brands : [];
                    data_default['brands'] = brands;

                    dispatch(setData({
                        response: { Msg: response.data.msg, success: response.data.success },
                        simpleToast: true,

                        loading: { Msg: 'Cargando...', isOpen: false },
                        refresh_list: true,
                        data_default: data_default
                    }))
                } else if (data.typeOption == "destroyDataUnit") {

                    let data_default = response.data.data_default ? response.data.data_default : {};
                    let categoories = response.data.data_default.categories ? response.data.data_default.categories : [];
                    let subcategories = [];
                    categoories.forEach((category) => {
                        if (category.sub_categories) {
                            subcategories.push(...category.sub_categories);
                        }
                    });
                    data_default['subcategories'] = subcategories;
                    let units = response.data.data_default.units_array ? response.data.data_default.units_array : [];
                    data_default['subcategories'] = subcategories;
                    data_default['units'] = units;
                    let brands = response.data.data_default.brands ? response.data.data_default.brands : [];
                    data_default['brands'] = brands;

                    dispatch(setData({
                        response: { Msg: response.data.msg, success: response.data.success },
                        simpleToast: true,

                        loading: { Msg: 'Cargando...', isOpen: false },
                        refresh_list: true,
                        data_default: data_default
                    }))
                }

                if (data.typeOption == "saveDataCategorie") {
                    let data_default = response.data.data_default ? response.data.data_default : {};
                    let categoories = response.data.data_default.categories ? response.data.data_default.categories : [];
                    let subcategories = [];
                    categoories.forEach((category) => {
                        if (category.sub_categories) {
                            subcategories.push(...category.sub_categories);
                        }
                    });
                    data_default['subcategories'] = subcategories;
                    let units = response.data.data_default.units_array ? response.data.data_default.units_array : [];
                    data_default['subcategories'] = subcategories;
                    data_default['units'] = units;
                    let brands = response.data.data_default.brands ? response.data.data_default.brands : [];
                    data_default['brands'] = brands;

                    dispatch(setData({
                        response: { Msg: response.data.msg, success: response.data.success },
                        simpleToast: true,

                        loading: { Msg: 'Cargando...', isOpen: false },
                        refresh_list: true,
                        data_default: data_default
                    }))
                } else if (data.typeOption == "updateDataCategorie") {
                    let data_default = response.data.data_default ? response.data.data_default : {};
                    let categoories = response.data.data_default.categories ? response.data.data_default.categories : [];
                    let subcategories = [];
                    categoories.forEach((category) => {
                        if (category.sub_categories) {
                            subcategories.push(...category.sub_categories);
                        }
                    });
                    data_default['subcategories'] = subcategories;
                    let units = response.data.data_default.units_array ? response.data.data_default.units_array : [];
                    data_default['subcategories'] = subcategories;
                    data_default['units'] = units;
                    let brands = response.data.data_default.brands ? response.data.data_default.brands : [];
                    data_default['brands'] = brands;

                    dispatch(setData({
                        response: { Msg: response.data.msg, success: response.data.success },
                        simpleToast: true,

                        loading: { Msg: 'Cargando...', isOpen: false },
                        refresh_list: true,
                        data_default: data_default
                    }))
                } else if (data.typeOption == "destroyDataCategorie") {
                    let data_default = response.data.data_default ? response.data.data_default : {};
                    let categoories = response.data.data_default.categories ? response.data.data_default.categories : [];
                    let subcategories = [];
                    categoories.forEach((category) => {
                        if (category.sub_categories) {
                            subcategories.push(...category.sub_categories);
                        }
                    });
                    data_default['subcategories'] = subcategories;
                    let units = response.data.data_default.units_array ? response.data.data_default.units_array : [];
                    data_default['subcategories'] = subcategories;
                    data_default['units'] = units;
                    let brands = response.data.data_default.brands ? response.data.data_default.brands : [];
                    data_default['brands'] = brands;
                    dispatch(setData({
                        response: { Msg: response.data.msg, success: response.data.success },
                        simpleToast: true,

                        loading: { Msg: 'Cargando...', isOpen: false },
                        refresh_list: true,
                        data_default: data_default
                    }))
                }

                if (data.typeOption == "saveDatabrand") {
                    let data_default = response.data.data_default ? response.data.data_default : {};
                    let categoories = response.data.data_default.categories ? response.data.data_default.categories : [];
                    let subcategories = [];
                    categoories.forEach((category) => {
                        if (category.sub_categories) {
                            subcategories.push(...category.sub_categories);
                        }
                    });
                    data_default['subcategories'] = subcategories;
                    let units = response.data.data_default.units_array ? response.data.data_default.units_array : [];
                    data_default['subcategories'] = subcategories;
                    data_default['units'] = units;
                    let brands = response.data.data_default.brands ? response.data.data_default.brands : [];
                    data_default['brands'] = brands;
                    dispatch(setData({
                        response: { Msg: response.data.msg, success: response.data.success },
                        simpleToast: true,

                        loading: { Msg: 'Cargando...', isOpen: false },
                        refresh_list: true,
                        data_default: data_default
                    }))
                } else if (data.typeOption == "updateDatabrand") {
                    let data_default = response.data.data_default ? response.data.data_default : {};
                    let categoories = response.data.data_default.categories ? response.data.data_default.categories : [];
                    let subcategories = [];
                    categoories.forEach((category) => {
                        if (category.sub_categories) {
                            subcategories.push(...category.sub_categories);
                        }
                    });
                    data_default['subcategories'] = subcategories;
                    let units = response.data.data_default.units_array ? response.data.data_default.units_array : [];
                    data_default['subcategories'] = subcategories;
                    data_default['units'] = units;
                    let brands = response.data.data_default.brands ? response.data.data_default.brands : [];
                    data_default['brands'] = brands;
                    dispatch(setData({
                        response: { Msg: response.data.msg, success: response.data.success },
                        simpleToast: true,

                        loading: { Msg: 'Cargando...', isOpen: false },
                        refresh_list: true,
                        data_default: data_default
                    }))
                } else if (data.typeOption == "destroyDatabrand") {
                    let data_default = response.data.data_default ? response.data.data_default : {};
                    let categoories = response.data.data_default.categories ? response.data.data_default.categories : [];
                    let subcategories = [];
                    categoories.forEach((category) => {
                        if (category.sub_categories) {
                            subcategories.push(...category.sub_categories);
                        }
                    });
                    data_default['subcategories'] = subcategories;
                    let units = response.data.data_default.units_array ? response.data.data_default.units_array : [];
                    data_default['subcategories'] = subcategories;
                    data_default['units'] = units;
                    let brands = response.data.data_default.brands ? response.data.data_default.brands : [];
                    data_default['brands'] = brands;
                    dispatch(setData({
                        response: { Msg: response.data.msg, success: response.data.success },
                        simpleToast: true,

                        loading: { Msg: 'Cargando...', isOpen: false },
                        refresh_list: true,
                        data_default: data_default
                    }))
                }

                if (data.typeOption == "saveDatavariation") {
                    let data_default = response.data.data_default ? response.data.data_default : {};
                    let categoories = response.data.data_default.categories ? response.data.data_default.categories : [];
                    let subcategories = [];
                    categoories.forEach((category) => {
                        if (category.sub_categories) {
                            subcategories.push(...category.sub_categories);
                        }
                    });
                    data_default['subcategories'] = subcategories;
                    let units = response.data.data_default.units_array ? response.data.data_default.units_array : [];
                    data_default['subcategories'] = subcategories;
                    data_default['units'] = units;
                    let brands = response.data.data_default.brands ? response.data.data_default.brands : [];
                    data_default['brands'] = brands;
                    dispatch(setData({
                        response: { Msg: response.data.msg, success: response.data.success },
                        simpleToast: true,

                        loading: { Msg: 'Cargando...', isOpen: false },
                        refresh_list: true,
                        data_default: data_default
                    }))
                } else if (data.typeOption == "updateDatavariation") {
                    let data_default = response.data.data_default ? response.data.data_default : {};
                    let categoories = response.data.data_default.categories ? response.data.data_default.categories : [];
                    let subcategories = [];
                    categoories.forEach((category) => {
                        if (category.sub_categories) {
                            subcategories.push(...category.sub_categories);
                        }
                    });
                    data_default['subcategories'] = subcategories;
                    let units = response.data.data_default.units_array ? response.data.data_default.units_array : [];
                    data_default['subcategories'] = subcategories;
                    data_default['units'] = units;
                    let brands = response.data.data_default.brands ? response.data.data_default.brands : [];
                    data_default['brands'] = brands;
                    dispatch(setData({
                        response: { Msg: response.data.msg, success: response.data.success },
                        simpleToast: true,

                        loading: { Msg: 'Cargando...', isOpen: false },
                        refresh_list: true,
                        data_default: data_default
                    }))
                } else if (data.typeOption == "destroyDatavariation") {
                    let data_default = response.data.data_default ? response.data.data_default : {};
                    let categoories = response.data.data_default.categories ? response.data.data_default.categories : [];
                    let subcategories = [];
                    categoories.forEach((category) => {
                        if (category.sub_categories) {
                            subcategories.push(...category.sub_categories);
                        }
                    });
                    data_default['subcategories'] = subcategories;
                    let units = response.data.data_default.units_array ? response.data.data_default.units_array : [];
                    data_default['subcategories'] = subcategories;
                    data_default['units'] = units;
                    let brands = response.data.data_default.brands ? response.data.data_default.brands : [];
                    data_default['brands'] = brands;
                    dispatch(setData({
                        response: { Msg: response.data.msg, success: response.data.success },
                        simpleToast: true,

                        loading: { Msg: 'Cargando...', isOpen: false },
                        refresh_list: true,
                        data_default: data_default
                    }))
                } else if (data.typeOption == "saveDataproduct") {
                    dispatch(setData({
                        response: { Msg: response.data.msg, success: response.data.success },
                        simpleToast: true,

                        loading: { Msg: 'Cargando...', isOpen: false },
                        refresh_list: true
                    }));
                } else if (data.typeOption == "updateDataproduct") {
                    dispatch(setData({
                        response: { Msg: response.data.msg, success: response.data.success },
                        simpleToast: true,

                        loading: { Msg: 'Cargando...', isOpen: false },
                        refresh_list: true
                    }));
                } else if (data.typeOption == "destroyDataproduct") {
                    dispatch(setData({
                        response: { Msg: response.data.msg, success: response.data.success },
                        simpleToast: true,
                        loading: { Msg: 'Cargando...', isOpen: false },
                        refresh_list: true
                    }));
                }



            },
            (err) => {
                dispatch(setData({
                    loading: { Msg: 'Ocurrio un error...', isOpen: false },
                }));
            }
        );
    }
};

export default {
    get_,
    post_,
    setData
}